import { Controller, useFormContext, useWatch } from "react-hook-form";
import { action, dateFrom, trigger } from "../../../../../types/automation";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

export default function AutomationDateFromControl() {
  const { register, control } = useFormContext();

  const action: action = useWatch({
    name: "action",
    control,
  });

  const requiredActions: action[] = [
    "고객 설치날짜 변경",
    "고객 AS날짜 변경",
    "고객 보증기간 변경",
    "고객 접수날짜 변경",
  ];

  const trigger: trigger = useWatch({
    name: "trigger",
    control,
  });

  const dateFroms: dateFrom[] = ["보고일자"];

  if (!requiredActions.includes(action) || !["정산 등록"].includes(trigger)) {
    return null;
  }

  return (
    <div className="flex flex-col gap-1">
      <div className="font-light">날짜변경 기준일</div>
      <Controller
        name="dateFrom"
        control={control}
        render={({ field }) => (
          <Select
            margin="none"
            size="small"
            required
            className="shadow-md"
            color="success"
            value={field.value || 0}
            onChange={field.onChange}
            onBlur={field.onBlur}
            name={field.name}
            ref={field.ref}
            disabled={field.disabled}
          >
            <MenuItem value={0}>조건 발동일</MenuItem>
            {dateFroms.map(a => (
              <MenuItem key={a} value={a}>
                {a}
              </MenuItem>
            ))}
          </Select>
        )}
      />
    </div>
  );
}
